import { create } from "zustand";
import { SureProjectId } from "../types/log";

const STORAGE_KEY = "healthsure-platform";

type PlatformChoice = SureProjectId | "all";

const readInitial = (): PlatformChoice => {
  try {
    return (localStorage.getItem(STORAGE_KEY) as PlatformChoice) || "all";
  } catch {
    return "all";
  }
};

// ----------------------- ONE PLATFORM FILTER FOR EVERY PAGE ------------------------------------
export const usePlatform = create<{ platform: PlatformChoice; setPlatform: (platform: PlatformChoice) => void }>((set) => ({
  platform: readInitial(),
  setPlatform: (platform) => {
    try {
      localStorage.setItem(STORAGE_KEY, platform);
    } catch {
      // ----------------------- STORAGE BLOCKED: KEEP IN MEMORY ONLY ------------------------------------
    }
    set({ platform });
  },
}));

export const platformParam = (platform: PlatformChoice) => (platform === "all" ? undefined : platform);
